import { gql } from "@apollo/client";

export const ALLOCATION_BY_SECURITY_TYPE_FIELDS = gql`
  fragment AllocationBySecurityTypeFields on GrouppedAnalyticsDTO {
    allocationByType: grouppedAnalytics {
      code
      name
      firstAnalysis {
        marketValue
        marketUnitPriceDate
        tradeAmount
        twr
      }
      allocationsBySecurity: grouppedAnalytics {
        code
        name
        security {
          id
          isinCode
          countryCode
          currencyCode
          tagsAsList
        }
        firstAnalysis {
          marketValue
          marketUnitPriceDate
          tradeAmount
          fxRate
          amount
          purchaseTradeAmount
          twr
          accrual
        }
      }
    }
  }
`;

export const PORTFOLIO_REPORT_HOLDINGS_DETAILS_FIELDS = gql`
  fragment PortfolioReportHoldingDetailsFields on PortfolioReport {
    holdingPositions: portfolioReportItems {
      portfolioId
      security {
        id
      }
      amount
      purchaseTradeAmount
      marketValue
      marketDate
      marketFxRate
      amountFromOpenTradeOrders
      amountFromSentTradeOrders
      tradeAmountFromOpenTradeOrders
      tradeAmountFromSentTradeOrders
    }
  }
`;

export const PORTFOLIO_REPORT_UNPAID_TRANSACTIONS_FIELDS = gql`
  fragment PortfolioReportUnpaidTransactionsFields on PortfolioReport {
    unpaidTransactions {
      id
      security {
        id
      }
      typeCode
      typeName
      type {
        typeCode
        amountEffect
      }
      tradeAmountInEffective
      securityCode
      securityName
      amount
      tradeAmount
    }
  }
`;
